import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_PUBLIC_DOCUMENTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_PUBLIC_DOCUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_PUBLIC_DOCUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_PUBLIC_DOCUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_PUBLIC_DOCUMENT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
